export default "__VITE_ASSET__DOF_XTSx__"